/**
 * Pack Finder results page (sections/sis-quiz-results.liquid).
 *
 * Filter changes submit as a GET to the same page so Liquid can re-resolve
 * the mapping table. Chip "X" buttons drop one query param and reload.
 */
(function () {
  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-sis-results]');
    roots.forEach(function (root) {
      if (root.getAttribute('data-sis-ready')) return;
      root.setAttribute('data-sis-ready', 'true');
      initResults(root);
    });
  }

  function initResults(root) {
    var path = root.getAttribute('data-path') || window.location.pathname;
    var form = root.querySelector('[data-sis-results-form]');

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        navigate(path, serializeForm(form));
      });
      form.addEventListener('change', function (event) {
        var input = event.target;
        if (!input || input.type !== 'radio' || !input.name) return;
        form.querySelectorAll('input[name="' + input.name + '"]').forEach(function (el) {
          var pill = el.closest('.sis-results__pill');
          if (pill) pill.classList.toggle('is-active', el.checked);
        });
      });
    }

    root.querySelectorAll('[data-sis-chip-remove]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = currentParams();
        var kind = button.getAttribute('data-sis-chip-remove');
        var value = button.getAttribute('data-value') || '';
        if (kind === 'subject') {
          var remaining = (next.get('sis_subjects') || '')
            .split(',')
            .map(function (item) {
              return item.trim();
            })
            .filter(function (item) {
              return item && item !== value;
            });
          if (remaining.length) next.set('sis_subjects', remaining.join(','));
          else next.delete('sis_subjects');
        } else if (kind) {
          next.delete(kind);
        }
        navigate(path, next);
      });
    });

    root.querySelectorAll('[data-sis-reset]').forEach(function (button) {
      button.addEventListener('click', function () {
        var href = button.getAttribute('data-href');
        if (href) window.location.href = href;
      });
    });

    var tagGrid = root.querySelector('[data-sis-tag-grid]');
    if (tagGrid) loadTagGrid(root, tagGrid);

    initFiltersDisclosure(root);
  }

  function initFiltersDisclosure(root) {
    var details = root.querySelector('[data-sis-filters]');
    if (!details) return;
    var panel = details.querySelector('.sis-results__filters-panel');
    var query = window.matchMedia('(max-width: 749px)');

    function sync() {
      if (!query.matches) details.open = true;
      var collapsed = query.matches && !details.open;
      if (!panel) return;
      if (collapsed) panel.setAttribute('inert', '');
      else panel.removeAttribute('inert');
    }

    details.addEventListener('toggle', sync);
    if (query.addEventListener) query.addEventListener('change', sync);
    sync();
  }

  function loadTagGrid(root, grid) {
    var tag = grid.getAttribute('data-sis-tag') || '';
    if (!tag) return;
    var params = new URLSearchParams();
    params.set('view', 'sis-tag');
    params.set('type', 'product');
    params.set('q', 'tag:"' + tag + '"');
    params.set('options[unavailable_products]', 'show');
    params.set('sis_tag', tag);
    ['sis_sort', 'sis_min', 'sis_max', 'sis_exclude', 'sis_badge', 'sis_format', 'sis_audience', 'sis_details', 'sis_buy'].forEach(
      function (key) {
        var value = grid.getAttribute('data-' + key.replace(/_/g, '-'));
        if (value) params.set(key, value);
      }
    );

    var cards = [];
    var heroLink = root.querySelector('.sis-result-card--hero a[href]');
    var heroPath = '';
    if (heroLink) {
      try {
        heroPath = new URL(heroLink.getAttribute('href'), window.location.origin).pathname;
      } catch (error) {
        heroPath = '';
      }
    }

    function pull(url) {
      return fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('tag search failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('[data-sis-tag-results]');
          if (!source) return;
          source.querySelectorAll('.sis-result-card').forEach(function (card) {
            if (keepTagCard(card, grid, heroPath)) cards.push(card);
          });
          var next = source.querySelector('[data-sis-tag-next]');
          if (!next) return;
          var nextUrl = new URL(next.getAttribute('data-sis-tag-next'), window.location.origin);
          nextUrl.searchParams.set('view', 'sis-tag');
          nextUrl.searchParams.delete('section_id');
          nextUrl.searchParams.set('sis_tag', tag);
          return pull(nextUrl.toString());
        });
    }

    pull('/search?' + params.toString())
      .then(function () {
        sortTagCards(cards, grid.getAttribute('data-sis-sort'));
        if (!cards.length) {
          grid.innerHTML = '<p class="sis-results__empty">Nu sunt alte pachete cu acest tag pentru filtrele alese.</p>';
        } else {
          grid.innerHTML = cards
            .map(function (card) {
              return card.outerHTML;
            })
            .join('');
        }
        updateTagCount(root, cards.length + (heroPath ? 1 : 0));
      })
      .catch(function () {
        grid.innerHTML = '<p class="sis-results__empty">Nu am putut încărca pachetele. Reîncearcă.</p>';
      });
  }

  function foldSubjectText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function subjectsInText(value) {
    var text = foldSubjectText(value);
    var found = {};
    var rules = [
      ['matematica', 'mate'],
      ['informatica', 'info'],
      ['psihologie', 'psihologie'],
      ['sociologie', 'sociologie'],
      ['filosofie', 'filosofie'],
      ['filozofie', 'filosofie'],
      ['geografie', 'geografie'],
      ['economie', 'economie'],
      ['biologie', 'bio'],
      ['istorie', 'istorie'],
      ['fizica', 'fizica'],
      ['chimie', 'chimie'],
      ['logica', 'logica'],
      ['romana', 'romana'],
      ['geogra', 'geografie'],
      ['mate', 'mate'],
      ['info', 'info'],
      ['bio', 'bio']
    ];
    rules.forEach(function (rule) {
      var token = rule[0];
      var pattern = new RegExp('(^|[^a-z])' + token + '([^a-z]|$)');
      if (!pattern.test(text)) return;
      found[rule[1]] = true;
      text = text.replace(new RegExp(token, 'g'), ' ');
    });
    return Object.keys(found);
  }

  function selectedSubjects(grid) {
    return (grid.getAttribute('data-sis-subjects') || '')
      .split(',')
      .map(function (part) {
        return subjectsInText(part)[0] || '';
      })
      .filter(Boolean);
  }

  function keepTagCard(card, grid, heroPath) {
    var link = card.querySelector('a[href]');
    if (link && heroPath) {
      try {
        if (new URL(link.getAttribute('href'), window.location.origin).pathname === heroPath) return false;
      } catch (error) {}
    }
    var price = parseInt(card.getAttribute('data-price') || '', 10);
    if (price || price === 0) {
      var min = grid.getAttribute('data-sis-min');
      var max = grid.getAttribute('data-sis-max');
      if (min && price < Number(min) * 100) return false;
      if (max && price > Number(max) * 100) return false;
    }
    var format = (grid.getAttribute('data-sis-format') || '').toLowerCase();
    if (format === 'fizic' || format === 'digital') {
      var cardLink = card.querySelector('a[href]');
      var path = '';
      if (cardLink) {
        try {
          path = new URL(cardLink.getAttribute('href'), window.location.origin).pathname.toLowerCase();
        } catch (error) {
          path = '';
        }
      }
      var isDigital = /ebook|produse-digitale|subiect-1-ab/.test(path);
      if (format === 'digital' && !isDigital) return false;
      if (format === 'fizic' && isDigital) return false;
    }
    var allowed = selectedSubjects(grid);
    if (allowed.length) {
      var title = (card.querySelector('.sis-result-card__title') || {}).textContent || '';
      var productPath = '';
      var productLink = card.querySelector('a[href]');
      if (productLink) {
        try {
          productPath = new URL(productLink.getAttribute('href'), window.location.origin).pathname;
        } catch (error) {
          productPath = '';
        }
      }
      var covered = subjectsInText(title + ' ' + productPath);
      if (!covered.length) return false;
      for (var i = 0; i < covered.length; i++) {
        if (allowed.indexOf(covered[i]) === -1) return false;
      }
    }
    return true;
  }

  function sortTagCards(cards, sort) {
    if (sort !== 'price-ascending' && sort !== 'price-descending' && sort !== 'title-ascending') return;
    cards.sort(function (a, b) {
      if (sort === 'title-ascending') {
        var titleA = (a.querySelector('.sis-result-card__title') || {}).textContent || '';
        var titleB = (b.querySelector('.sis-result-card__title') || {}).textContent || '';
        return titleA.localeCompare(titleB, 'ro');
      }
      var priceA = parseInt(a.getAttribute('data-price') || '0', 10);
      var priceB = parseInt(b.getAttribute('data-price') || '0', 10);
      return sort === 'price-descending' ? priceB - priceA : priceA - priceB;
    });
  }

  function updateTagCount(root, count) {
    var label = count === 1 ? '1 produs găsit' : count + ' produse găsite';
    var apply = count === 1 ? 'Afișează 1 produs' : 'Afișează ' + count + ' produse';
    var countEl = root.querySelector('.sis-results__count');
    if (countEl) countEl.textContent = label;
    var applyEl = root.querySelector('[data-sis-apply]');
    if (applyEl) applyEl.textContent = apply;
  }

  function currentParams() {
    return new URLSearchParams(window.location.search);
  }

  function serializeForm(form) {
    var params = currentParams();
    var data = new FormData(form);
    ['sis_profile', 'sis_format', 'sis_category', 'sis_class', 'sis_type', 'sis_sort', 'sis_min', 'sis_max'].forEach(
      function (key) {
        params.delete(key);
      }
    );
    data.forEach(function (value, key) {
      if (value === '' || value == null) params.delete(key);
      else params.set(key, String(value));
    });
    if (params.get('sis_category') !== 'gimnaziu') params.delete('sis_class');
    return params;
  }

  function navigate(path, params) {
    var query = params.toString();
    window.location.href = query ? path + '?' + query : path;
  }

  function querySignature(search) {
    var params = new URLSearchParams(search || '');
    params.delete('sis_r');
    var keys = [];
    params.forEach(function (_value, key) {
      keys.push(key);
    });
    keys.sort();
    return keys
      .map(function (key) {
        return key + '=' + (params.get(key) || '');
      })
      .join('&');
  }

  function reloadIfStaleResults() {
    var root = document.querySelector('[data-sis-results]');
    if (!root) return;
    var rendered = querySignature(root.getAttribute('data-sis-query') || '');
    var live = querySignature(window.location.search);
    if (!live || rendered === live) return;
    var stamp = window.location.pathname + '?' + live;
    try {
      if (sessionStorage.getItem('sis-results-reload') === stamp) return;
      sessionStorage.setItem('sis-results-reload', stamp);
    } catch (e) {}
    var next = new URL(window.location.href);
    next.searchParams.set('sis_r', String(Date.now()));
    window.location.replace(next.toString());
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      var next = new URL(window.location.href);
      next.searchParams.set('sis_r', String(Date.now()));
      window.location.replace(next.toString());
      return;
    }
    reloadIfStaleResults();
  });
  reloadIfStaleResults();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    boot(event.target);
  });
})();
